<div class="container d-flex justify-content-between">
  <div class="line d-flex flex-column justify-content-between" *ngFor="let line of lines">
    <div class="line-h" *ngFor="let line of lines">
      <div class="line-v"></div>
    </div>
  </div>
</div>
